<app-summary-field *ngIf="email">
    <a [href]="'mailto:' + email">{{email}}</a>
</app-summary-field>
